import { all } from "redux-saga/effects";
import Auth from "./Auth";
import Counts from "./Counts";
import TinyKeys from "./TinyKeys";

export default function* rootSaga(getState) {
  yield all([Auth(), Counts(), TinyKeys()]);
}
